import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchOpticiansClinics(page, pageSize) {
    let url = `/Optician/Clinic/GetOpticianClinicsAppt/${encodeURIComponent(pageSize)}/${encodeURIComponent(page)}`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Clinics found.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Clinics: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchClinicSchedule(clinicId, date) {
    let url = `/Optician/Clinic/GetClinicAppointmentSchedule/${encodeURIComponent(clinicId)}/${encodeURIComponent(date)}`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Clinic Schedules found.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Clinic Schedules: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}